import { LayoutHOC } from 'base/ui/layout/layout';
import createAppointmentPage from './Appointment';
import createDetailContactSegment from './ContactSegmentation/detail';
import createDetailCustomerSegment from './CustomerSegmentation/detail';
import createCustomerUnidentified from './CustomerUnidentified';
import createDetailCustomerUnidentified from './CustomerUnidentified/detail';
import { customerRoutes } from './routes';

export const createCustomerPage = (layoutHOC: LayoutHOC) => {
  const Appointment = createAppointmentPage();
  // -- Customer srgment --------------------------------------
  const CustomerSegmentation = createDetailCustomerSegment();
  const DetailCustomerSegment = createDetailCustomerSegment();

  // -- Contact srgment --------------------------------------
  const ContactSegmentation = createDetailContactSegment();
  const DetailContactSegment = createDetailContactSegment();

  // -- Khách hàng chưa định danh ----------------------------
  const CustomerUnidentified = createCustomerUnidentified();
  const DetailCustomerUnidentified = createDetailCustomerUnidentified();

  const CustomerPage = layoutHOC(customerRoutes);

  return () => (
    <CustomerPage
      Appointment={Appointment}
      CustomerSegmentation={CustomerSegmentation}
      DetailCustomerSegment={DetailCustomerSegment}
      ContactSegmentation={ContactSegmentation}
      DetailContactSegment={DetailContactSegment}
      CustomerUnidentified={CustomerUnidentified}
      DetailCustomerUnidentified={DetailCustomerUnidentified}
    />
  );
};
